export default "<div class=\"gifHolder\">\n    <i class=\"fas fa-solid fa-circle-notch fa-spin\"></i>\n</div>"